<div class="header-overlay" *ngIf="isDropdown"></div>
<div class="profile-basic-header w-100" [ngClass]="{'w-100': isMe === true || showVolume}">
  <div class="d-flex px-3 justify-content-between">
    <div class="d-flex">
      <div *ngIf="loadingState" class="d-flex justify-content-center align-items-center box-48 rounded-circle bg-grey profile-img-section">
      </div>
      <div *ngIf="!loadingState" (click)="redirectToProfile()" class="d-flex cursor-pointer">
        <div  class="d-flex justify-content-center align-items-center box-48 rounded-circle bg-grey profile-img-section">
          <img *ngIf="profileImage" class="box-48 rounded-circle" [src]="profileImage" alt="pic"  onerror="this.src='assets/themes/icons/user-profile-placeholder.svg'">
          <img *ngIf="!profileImage" src="assets/themes/icons/user-profile-placeholder.svg">
        </div>
        <div class="ml-2" >
          <span class="text-white">
            {{isMe ? youText : fullName}}
          </span>
          <p class="text-white fnt-size12px ">
            <span>{{speciality}}</span>
            <span class="ml-2">
              <span class="d-inline-flex dotCreation"></span>
              {{createdOn | ageing : "user_story"}}
            </span>
          </p>
        </div>
      </div>
    </div>
    <div class="position-relative">
      <div class="d-flex">
        <button 
          class="my-2 flex-shrink-0 d-none btn-desing small outline btn border text-white ng-star-inserted py-0 px-2"
          (click)="sendRequest()">
          <span *ngIf="channelId === 0">
            Connect
          </span>
          <span *ngIf="channelId !== 0">
            Follow+
          </span>
        </button>
        <span *ngIf="showVolume" class="ml-3  mt-1 mr-3 cursor-pointer flex-shrink-0">
          <img [src]="!isMuted ? 'assets/images/mute.svg':'assets/images/unmute.svg'" alt="mute" (click)="setMute()"
            width="32" height="32">
        </span>
        <span ngbDropdown *ngIf="isMe === true" (openChange)="toggleProgressCounter($event)"  class="mt-1 cursor-pointer flex-shrink-0">
          <span id="dropdownBasic1" ngbDropdownToggle class="cursor-pointer">
            <img src="assets/images/dots.svg" alt="dots" [width]="32" [height]="32">
            <div ngbDropdownMenu class="header-dropdown ml-3" aria-labelledby="dropdownBasic1">
              <ul class="bg-white header-dropdown-list mb-0">
                <ng-container *ngFor="let list of headerDropdownList">
                  <li *ngIf="!is_me && list.id === headerActions.DELETE" class="cursor-pointer secondary-paragraph-bold"
                    (click)="doAction(list.id)">
                    {{list.text}}
                  </li>
                </ng-container>
              </ul>
            </div>
          </span>
          <div>
          </div>
        </span>
        <span class="ml-4 mt-1 cursor-pointer flex-shrink-0 d-block d-md-none" (click)="closeStories()">
          <img width="32px" src="assets/images/cross.svg" alt="cross">
        </span>
      </div>
    </div>
  </div>
</div>
